import { useMediaQuery } from '@material-ui/core'

export function useIsHorizontal() {
  const matches = useMediaQuery(`(orientation: landscape)`)

  return matches
}
